export const REFRESH_TOKEN = 'REFRESH/REFRESH_TOKEN';

export function refreshToken() {
    return {
        type: REFRESH_TOKEN
    };
}
